import { getSchoolIdFromEmail } from '../hooks/useSchool'

// value is for display, label is for backend searching
// no whitespace in label
const allDepts_UCB: { value: string; label: string }[] = [
    { value: 'COMPSCI', label: 'COMPSCI' },
    { value: 'DATA', label: 'DATA' },
    { value: 'STAT', label: 'STAT' },
    { value: 'MATH', label: 'MATH' },
    { value: 'INTEGBI', label: 'INTEGBI' },
    { value: 'MCELLBI', label: 'MCELLBI' },
    { value: 'BIOLOGY', label: 'BIOLOGY' },
    { value: 'CHEM', label: 'CHEM' },
    { value: 'COG SCI', label: 'COGSCI' },
    { value: 'PSYCH', label: 'PSYCH' },
    { value: 'ECON', label: 'ECON' },
    { value: 'UGBA', label: 'UGBA' },
    { value: 'EECS', label: 'EECS' },
    { value: 'COM LIT', label: 'COMLIT' },
    { value: 'AERO ENG', label: 'AEROENG' },
    { value: 'AEROSPC', label: 'AEROSPC' },
    { value: 'AFRICAM', label: 'AFRICAM' },
    { value: 'AGRS', label: 'AGRS' },
    { value: 'AHMA', label: 'AHMA' },
    { value: 'AMERSTD', label: 'AMERSTD' },
    { value: 'ANTHRO', label: 'ANTHRO' },
    { value: 'ARABIC', label: 'ARABIC' },
    { value: 'ARCH', label: 'ARCH' },
    { value: 'ARMENI', label: 'ARMENI' },
    { value: 'ART', label: 'ART' },
    { value: 'ASAMST', label: 'ASAMST' },
    { value: 'ASIANST', label: 'ASIANST' },
    { value: 'AST', label: 'AST' },
    { value: 'ASTRON', label: 'ASTRON' },
    { value: 'BANGLA', label: 'BANGLA' },
    { value: 'BIO ENG', label: 'BIOENG' },
    { value: 'BIOPHY', label: 'BIOPHY' },
    { value: 'BOSCRSR', label: 'BOSCRSR' },
    { value: 'BUDDSTD', label: 'BUDDSTD' },
    { value: 'BULGARI', label: 'BULGARI' },
    { value: 'BURMESE', label: 'BURMESE' },
    { value: 'CATALAN', label: 'CATALAN' },
    { value: 'CELTIC', label: 'CELTIC' },
    { value: 'CHICANO', label: 'CHICANO' },
    { value: 'CHINESE', label: 'CHINESE' },
    { value: 'CHM ENG', label: 'CHMENG' },
    { value: 'CIV ENG', label: 'CIVENG' },
    { value: 'CLASSIC', label: 'CLASSIC' },
    { value: 'CMPBIO', label: 'CMPBIO' },
    { value: 'COLWRIT', label: 'COLWRIT' },
    { value: 'COMPBIO', label: 'COMPBIO' },
    { value: 'CRIT TH', label: 'CRITTH' },
    { value: 'CRWRIT', label: 'CRWRIT' },
    { value: 'CUNEIF', label: 'CUNEIF' },
    { value: 'CY PLAN', label: 'CYPLAN' },
    { value: 'CYBER', label: 'CYBER' },
    { value: 'CZECH', label: 'CZECH' },
    { value: 'DANISH', label: 'DANISH' },
    { value: 'DATASCI', label: 'DATASCI' },
    { value: 'DEMOG', label: 'DEMOG' },
    { value: 'DES INV', label: 'DESINV' },
    { value: 'DEV ENG', label: 'DEVENG' },
    { value: 'DEV STD', label: 'DEVSTD' },
    { value: 'DEVP', label: 'DEVP' },
    { value: 'DIGHUM', label: 'DIGHUM' },
    { value: 'DUTCH', label: 'DUTCH' },
    { value: 'EA LANG', label: 'EALANG' },
    { value: 'EDSTEM', label: 'EDSTEM' },
    { value: 'EDUC', label: 'EDUC' },
    { value: 'EGYPT', label: 'EGYPT' },
    { value: 'EL ENG', label: 'ELENG' },
    { value: 'ENGIN', label: 'ENGIN' },
    { value: 'ENGLISH', label: 'ENGLISH' },
    { value: 'ENV DES', label: 'ENVDES' },
    { value: 'ENV SCI', label: 'ENVSCI' },
    { value: 'ENVECON', label: 'ENVECON' },
    { value: 'EPS', label: 'EPS' },
    { value: 'ESPM', label: 'ESPM' },
    { value: 'ETH STD', label: 'ETHSTD' },
    { value: 'EUST', label: 'EUST' },
    { value: 'EWMBA', label: 'EWMBA' },
    { value: 'FILIPN', label: 'FILIPN' },
    { value: 'FILM', label: 'FILM' },
    { value: 'FINNISH', label: 'FINNISH' },
    { value: 'FOLKLOR', label: 'FOLKLOR' },
    { value: 'FRENCH', label: 'FRENCH' },
    { value: 'GEOG', label: 'GEOG' },
    { value: 'GERMAN', label: 'GERMAN' },
    { value: 'GLOBAL', label: 'GLOBAL' },
    { value: 'GMS', label: 'GMS' },
    { value: 'GPP', label: 'GPP' },
    { value: 'GREEK', label: 'GREEK' },
    { value: 'GSPDP', label: 'GSPDP' },
    { value: 'GWS', label: 'GWS' },
    { value: 'HEBREW', label: 'HEBREW' },
    { value: 'HINDI', label: 'HINDI' },
    { value: 'HISTART', label: 'HISTART' },
    { value: 'HISTORY', label: 'HISTORY' },
    { value: 'HMEDSCI', label: 'HMEDSCI' },
    { value: 'HUM', label: 'HUM' },
    { value: 'HUNGARI', label: 'HUNGARI' },
    { value: 'IAS', label: 'IAS' },
    { value: 'ICELAND', label: 'ICELAND' },
    { value: 'IND ENG', label: 'INDENG' },
    { value: 'INDONES', label: 'INDONES' },
    { value: 'INFO', label: 'INFO' },
    { value: 'IRANIAN', label: 'IRANIAN' },
    { value: 'ISF', label: 'ISF' },
    { value: 'ITALIAN', label: 'ITALIAN' },
    { value: 'JAPAN', label: 'JAPAN' },
    { value: 'JEWISH', label: 'JEWISH' },
    { value: 'JOURN', label: 'JOURN' },
    { value: 'KHMER', label: 'KHMER' },
    { value: 'KOREAN', label: 'KOREAN' },
    { value: 'LAN PRO', label: 'LANPRO' },
    { value: 'LATAMST', label: 'LATAMST' },
    { value: 'LATIN', label: 'LATIN' },
    { value: 'LAW', label: 'LAW' },
    { value: 'LD ARCH', label: 'LDARCH' },
    { value: 'LEGALST', label: 'LEGALST' },
    { value: 'LGBT', label: 'LGBT' },
    { value: 'LINGUIS', label: 'LINGUIS' },
    { value: 'MAT SCI', label: 'MATSCI' },
    { value: 'MBA', label: 'MBA' },
    { value: 'MEC ENG', label: 'MECENG' },
    { value: 'MED ST', label: 'MEDST' },
    { value: 'MEDIAST', label: 'MEDIAST' },
    { value: 'MELC', label: 'MELC' },
    { value: 'MFE', label: 'MFE' },
    { value: 'MIL AFF', label: 'MILAFF' },
    { value: 'MIL SCI', label: 'MILSCI' },
    { value: 'MONGOLN', label: 'MONGOLN' },
    { value: 'MPS', label: 'MPS' },
    { value: 'MUSIC', label: 'MUSIC' },
    { value: 'NAT RES', label: 'NATRES' },
    { value: 'NATAMST', label: 'NATAMST' },
    { value: 'NAV SCI', label: 'NAVSCI' },
    { value: 'NEUROSC', label: 'NEUROSC' },
    { value: 'NORWEGN', label: 'NORWEGN' },
    { value: 'NSE', label: 'NSE' },
    { value: 'NUC ENG', label: 'NUCENG' },
    { value: 'NUSCTX', label: 'NUSCTX' },
    { value: 'NWMEDIA', label: 'NWMEDIA' },
    { value: 'OPTOM', label: 'OPTOM' },
    { value: 'PACS', label: 'PACS' },
    { value: 'PB HLTH', label: 'PBHLTH' },
    { value: 'PERSIAN', label: 'PERSIAN' },
    { value: 'PHDBA', label: 'PHDBA' },
    { value: 'PHILOS', label: 'PHILOS' },
    { value: 'PHYS ED', label: 'PHYSED' },
    { value: 'PHYSICS', label: 'PHYSICS' },
    { value: 'PLANTBI', label: 'PLANTBI' },
    { value: 'POL SCI', label: 'POLSCI' },
    { value: 'POLECON', label: 'POLECON' },
    { value: 'POLISH', label: 'POLISH' },
    { value: 'PORTUG', label: 'PORTUG' },
    { value: 'PUB AFF', label: 'PUBAFF' },
    { value: 'PUB POL', label: 'PUBPOL' },
    { value: 'PUNJABI', label: 'PUNJABI' },
    { value: 'RDEV', label: 'RDEV' },
    { value: 'RHETOR', label: 'RHETOR' },
    { value: 'RUSSIAN', label: 'RUSSIAN' },
    { value: 'SANSKR', label: 'SANSKR' },
    { value: 'SASIAN', label: 'SASIAN' },
    { value: 'SCANDIN', label: 'SCANDIN' },
    { value: 'SCMATHE', label: 'SCMATHE' },
    { value: 'SEASIAN', label: 'SEASIAN' },
    { value: 'SEMITIC', label: 'SEMITIC' },
    { value: 'SLAVIC', label: 'SLAVIC' },
    { value: 'SOC WEL', label: 'SOCWEL' },
    { value: 'SOCIOL', label: 'SOCIOL' },
    { value: 'SPANISH', label: 'SPANISH' },
    { value: 'SSEASN', label: 'SSEASN' },
    { value: 'STRELIG', label: 'STRELIG' },
    { value: 'STS', label: 'STS' },
    { value: 'SWEDISH', label: 'SWEDISH' },
    { value: 'TAMIL', label: 'TAMIL' },
    { value: 'TELUGU', label: 'TELUGU' },
    { value: 'THAI', label: 'THAI' },
    { value: 'THEATER', label: 'THEATER' },
    { value: 'TIBETAN', label: 'TIBETAN' },
    { value: 'TURKISH', label: 'TURKISH' },
    { value: 'UGIS', label: 'UGIS' },
    { value: 'UKRAINI', label: 'UKRAINI' },
    { value: 'URDU', label: 'URDU' },
    { value: 'VIETNMS', label: 'VIETNMS' },
    { value: 'VIS SCI', label: 'VISSCI' },
    { value: 'VIS STD', label: 'VISSTD' },
    { value: 'X', label: 'X' },
    { value: 'XMBA', label: 'XMBA' },
    { value: 'YIDDISH', label: 'YIDDISH' }
]

const allDepts_UCLA: { value: string; label: string }[] = [
    { value: 'AERO ST', label: 'AEROST' },
    { value: 'AF AMER', label: 'AFAMER' },
    { value: 'AFRC ST', label: 'AFRCST' },
    { value: 'AM IND', label: 'AMIND' },
    { value: 'ASL', label: 'ASL' },
    { value: 'AN N EA', label: 'ANNEA' },
    { value: 'ANTHRO', label: 'ANTHRO' },
    { value: 'APP CHM', label: 'APPCHM' },
    { value: 'APPLING', label: 'APPLING' },
    { value: 'ARABIC', label: 'ARABIC' },
    { value: 'ARCHEOL', label: 'ARCHEOL' },
    { value: 'ARCH&UD', label: 'ARCH&UD' },
    { value: 'ARMENIA', label: 'ARMENIA' },
    { value: 'ART', label: 'ART' },
    { value: 'ART HIS', label: 'ARTHIS' },
    { value: 'ART&ARC', label: 'ART&ARC' },
    { value: 'ARTS ED', label: 'ARTSED' },
    { value: 'ASIAN', label: 'ASIAN' },
    { value: 'ASIA AM', label: 'ASIAAM' },
    { value: 'ASTR', label: 'ASTR' },
    { value: 'A&O SCI', label: 'A&OSCI' },
    { value: 'BIOENGR', label: 'BIOENGR' },
    { value: 'BIOINFO', label: 'BIOINFO' },
    { value: 'BIOL CH', label: 'BIOLCH' },
    { value: 'BIOMATH', label: 'BIOMATH' },
    { value: 'BMD RES', label: 'BMDRES' },
    { value: 'BIOSTAT', label: 'BIOSTAT' },
    { value: 'CH ENGR', label: 'CHENGR' },
    { value: 'CHEM', label: 'CHEM' },
    { value: 'CCAS', label: 'CCAS' },
    { value: 'CHIN', label: 'CHIN' },
    { value: 'C&EE', label: 'C&EE' },
    { value: 'CLASSIC', label: 'CLASSIC' },
    { value: 'CLUSTER', label: 'CLUSTER' },
    { value: 'COMM', label: 'COMM' },
    { value: 'CESC', label: 'CESC' },
    { value: 'COM HLT', label: 'COMHLT' },
    { value: 'COM LIT', label: 'COMLIT' },
    { value: 'C&S BIO', label: 'C&SBIO' },
    { value: 'COM SCI', label: 'COMSCI' },
    { value: 'CLT HTG', label: 'CLTHTG' },
    { value: 'DANCE', label: 'DANCE' },
    { value: 'DS BMED', label: 'DSBMED' },
    { value: 'DESMA', label: 'DESMA' },
    { value: 'DGT HUM', label: 'DGTHUM' },
    { value: 'DIS STD', label: 'DISSTD' },
    { value: 'DUTCH', label: 'DUTCH' },
    { value: 'EPS SCI', label: 'EPSSCI' },
    { value: 'EE BIOL', label: 'EEBIOL' },
    { value: 'ECON', label: 'ECON' },
    { value: 'EDUC', label: 'EDUC' },
    { value: 'EC ENGR', label: 'ECENGR' },
    { value: 'ENGR', label: 'ENGR' },
    { value: 'ENGL', label: 'ENGL' },
    { value: 'ESL', label: 'ESL' },
    { value: 'ENGCOMP', label: 'ENGCOMP' },
    { value: 'ENVIRON', label: 'ENVIRON' },
    { value: 'ENV HLT', label: 'ENVHLT' },
    { value: 'EPIDEM', label: 'EPIDEM' },
    { value: 'ETHNMUS', label: 'ETHNMUS' },
    { value: 'ELTS', label: 'ELTS' },
    { value: 'FILIPNO', label: 'FILIPNO' },
    { value: 'FILM TV', label: 'FILMTV' },
    { value: 'FOOD ST', label: 'FOODST' },
    { value: 'FRNCH', label: 'FRNCH' },
    { value: 'GENDER', label: 'GENDER' },
    { value: 'GEOG', label: 'GEOG' },
    { value: 'GERMAN', label: 'GERMAN' },
    { value: 'GLB HLT', label: 'GLBHLT' },
    { value: 'GJ STDS', label: 'GJSTDS' },
    { value: 'GLBL ST', label: 'GLBLST' },
    { value: 'GRAD PD', label: 'GRADPD' },
    { value: 'GREEK', label: 'GREEK' },
    { value: 'HLT POL', label: 'HLTPOL' },
    { value: 'HLT ADM', label: 'HLTADM' },
    { value: 'HEBREW', label: 'HEBREW' },
    { value: 'HIN-URD', label: 'HIN-URD' },
    { value: 'HIST', label: 'HIST' },
    { value: 'HNRS', label: 'HNRS' },
    { value: 'HUM GEN', label: 'HUMGEN' },
    { value: 'HNGAR', label: 'HNGAR' },
    { value: 'IL AMER', label: 'ILAMER' },
    { value: 'I E STD', label: 'IESTD' },
    { value: 'INDO', label: 'INDO' },
    { value: 'INF STD', label: 'INFSTD' },
    { value: 'I A STD', label: 'IASTD' },
    { value: 'INTL DV', label: 'INTLDV' },
    { value: 'I M STD', label: 'IMSTD' },
    { value: 'IRANIAN', label: 'IRANIAN' },
    { value: 'ISLM ST', label: 'ISLMST' },
    { value: 'ITALIAN', label: 'ITALIAN' },
    { value: 'JAPAN', label: 'JAPAN' },
    { value: 'JEWISH', label: 'JEWISH' },
    { value: 'KOREA', label: 'KOREA' },
    { value: 'LBR STD', label: 'LBRSTD' },
    { value: 'LATIN', label: 'LATIN' },
    { value: 'LATN AM', label: 'LATNAM' },
    { value: 'LGBTQS', label: 'LGBTQS' },
    { value: 'LIFESCI', label: 'LIFESCI' },
    { value: 'LING', label: 'LING' },
    { value: 'MGMT', label: 'MGMT' },
    { value: 'MAT SCI', label: 'MATSCI' },
    { value: 'MATH', label: 'MATH' },
    { value: 'MECH&AE', label: 'MECH&AE' },
    { value: 'MED', label: 'MED' },
    { value: 'MIMG', label: 'MIMG' },
    { value: 'M E STD', label: 'MESTD' },
    { value: 'MIL SCI', label: 'MILSCI' },
    { value: 'M PHARM', label: 'MPHARM' },
    { value: 'MOL BIO', label: 'MOLBIO' },
    { value: 'MOL TOX', label: 'MOLTOX' },
    { value: 'MCD BIO', label: 'MCDBIO' },
    { value: 'MC&IP', label: 'MC&IP' },
    { value: 'MUSC', label: 'MUSC' },
    { value: 'MSC IND', label: 'MSCIND' },
    { value: 'MUSCLG', label: 'MUSCLG' },
    { value: 'NAV SCI', label: 'NAVSCI' },
    { value: 'NR EAST', label: 'NREAST' },
    { value: 'NEURLGY', label: 'NEURLGY' },
    { value: 'NEURO', label: 'NEURO' },
    { value: 'NEUROSC', label: 'NEUROSC' },
    { value: 'NURSING', label: 'NURSING' },
    { value: 'OBGYN', label: 'OBGYN' },
    { value: 'ORL BIO', label: 'ORLBIO' },
    { value: 'PATH', label: 'PATH' },
    { value: 'PEDS', label: 'PEDS' },
    { value: 'PHILOS', label: 'PHILOS' },
    { value: 'PHYSICS', label: 'PHYSICS' },
    { value: 'PBMED', label: 'PBMED' },
    { value: 'PHYSCI', label: 'PHYSCI' },
    { value: 'PHYSIOL', label: 'PHYSIOL' },
    { value: 'POLSH', label: 'POLSH' },
    { value: 'POL SCI', label: 'POLSCI' },
    { value: 'PORTGSE', label: 'PORTGSE' },
    { value: 'COMPTNG', label: 'COMPTNG' },
    { value: 'PSYCTRY', label: 'PSYCTRY' },
    { value: 'PSYCH', label: 'PSYCH' },
    { value: 'PUB AFF', label: 'PUBAFF' },
    { value: 'PUB HLT', label: 'PUBHLT' },
    { value: 'PUB PLC', label: 'PUBPLC' },
    { value: 'QNT SCI', label: 'QNTSCI' },
    { value: 'RELIGN', label: 'RELIGN' },
    { value: 'RES PRC', label: 'RESPRC' },
    { value: 'ROMANIA', label: 'ROMANIA' },
    { value: 'RUSSN', label: 'RUSSN' },
    { value: 'SCAND', label: 'SCAND' },
    { value: 'SCI EDU', label: 'SCIEDU' },
    { value: 'SEMITIC', label: 'SEMITIC' },
    { value: 'SRB CRO', label: 'SRBCRO' },
    { value: 'SLAVC', label: 'SLAVC' },
    { value: 'SOC SC', label: 'SOCSC' },
    { value: 'SOC THT', label: 'SOCTHT' },
    { value: 'SOC WLF', label: 'SOCWLF' },
    { value: 'SOC GEN', label: 'SOCGEN' },
    { value: 'SOCIOL', label: 'SOCIOL' },
    { value: 'S ASIAN', label: 'SASIAN' },
    { value: 'SEASIAN', label: 'SEASIAN' },
    { value: 'SPAN', label: 'SPAN' },
    { value: 'STATS', label: 'STATS' },
    { value: 'SURGERY', label: 'SURGERY' },
    { value: 'SWAHILI', label: 'SWAHILI' },
    { value: 'THAI', label: 'THAI' },
    { value: 'THEATER', label: 'THEATER' },
    { value: 'TURKIC', label: 'TURKIC' },
    { value: 'UNIV ST', label: 'UNIVST' },
    { value: 'URBN PL', label: 'URBNPL' },
    { value: 'VIETMSE', label: 'VIETMSE' },
    { value: 'WL ARTS', label: 'WLARTS' },
    { value: 'YIDDSH', label: 'YIDDSH' }   
]

const allDepts_Stanford: { value: string; label: string }[] = [
    { value: 'AA', label: 'AA' },
    { value: 'ACCT', label: 'ACCT' },
    { value: 'AFRICAAM', label: 'AFRICAAM' },
    { value: 'ALP', label: 'ALP' },
    { value: 'AMHRLANG', label: 'AMHRLANG' },
    { value: 'AMSTUD', label: 'AMSTUD' },
    { value: 'ANES', label: 'ANES' },
    { value: 'ANTHRO', label: 'ANTHRO' },
    { value: 'APPPHYS', label: 'APPPHYS' },
    { value: 'ARABLANG', label: 'ARABLANG' },
    { value: 'ARCHLGY', label: 'ARCHLGY' },
    { value: 'ARMELANG', label: 'ARMELANG' },
    { value: 'ARTHIST', label: 'ARTHIST' },
    { value: 'ARTSINST', label: 'ARTSINST' },
    { value: 'ARTSTUDI', label: 'ARTSTUDI' },
    { value: 'ASLLANG', label: 'ASLLANG' },
    { value: 'ASNAMST', label: 'ASNAMST' },
    { value: 'ATHLETIC', label: 'ATHLETIC' },
    { value: 'BIO', label: 'BIO' },
    { value: 'BIOC', label: 'BIOC' },
    { value: 'BIOE', label: 'BIOE' },
    { value: 'BIOPHYS', label: 'BIOPHYS' },
    { value: 'BIOS', label: 'BIOS' },
    { value: 'BMDS', label: 'BMDS' },
    { value: 'BMP', label: 'BMP' },
    { value: 'BUSGEN', label: 'BUSGEN' },
    { value: 'CBIO', label: 'CBIO' },
    { value: 'CEE', label: 'CEE' },
    { value: 'CHEM', label: 'CHEM' },
    { value: 'CHEMENG', label: 'CHEMENG' },
    { value: 'CHILATST', label: 'CHILATST' },
    { value: 'CHINA', label: 'CHINA' },
    { value: 'CHINLANG', label: 'CHINLANG' },
    { value: 'CHPR', label: 'CHPR' },
    { value: 'CLASSICS', label: 'CLASSICS' },
    { value: 'CME', label: 'CME' },
    { value: 'COLLEGE', label: 'COLLEGE' },
    { value: 'COMM', label: 'COMM' },
    { value: 'COMPLIT', label: 'COMPLIT' },
    { value: 'COMPMED', label: 'COMPMED' },
    { value: 'CS', label: 'CS' },
    { value: 'CSB', label: 'CSB' },
    { value: 'CSRE', label: 'CSRE' },
    { value: 'CTL', label: 'CTL' },
    { value: 'CTS', label: 'CTS' },
    { value: 'CZECLANG', label: 'CZECLANG' },
    { value: 'DANCE', label: 'DANCE' },
    { value: 'DATASCI', label: 'DATASCI' },
    { value: 'DBIO', label: 'DBIO' },
    { value: 'DERM', label: 'DERM' },
    { value: 'DESIGN', label: 'DESIGN' },
    { value: 'DLCL', label: 'DLCL' },
    { value: 'EALC', label: 'EALC' },
    { value: 'EARTHSYS', label: 'EARTHSYS' },
    { value: 'EASTASN', label: 'EASTASN' },
    { value: 'EBS', label: 'EBS' },
    { value: 'ECON', label: 'ECON' },
    { value: 'EDUC', label: 'EDUC' },
    { value: 'EE', label: 'EE' },
    { value: 'EMED', label: 'EMED' },
    { value: 'ENERGY', label: 'ENERGY' },
    { value: 'ENGLISH', label: 'ENGLISH' },
    { value: 'ENGR', label: 'ENGR' },
    { value: 'ENVRES', label: 'ENVRES' },
    { value: 'EPI', label: 'EPI' },
    { value: 'EPS', label: 'EPS' },
    { value: 'ESOLLANG', label: 'ESOLLANG' },
    { value: 'ESS', label: 'ESS' },
    { value: 'ETHICSOC', label: 'ETHICSOC' },
    { value: 'FAMMED', label: 'FAMMED' },
    { value: 'FEMGEN', label: 'FEMGEN' },
    { value: 'FILILANG', label: 'FILILANG' },
    { value: 'FILMEDIA', label: 'FILMEDIA' },
    { value: 'FILMPROD', label: 'FILMPROD' },
    { value: 'FINANCE', label: 'FINANCE' },
    { value: 'FRENCH', label: 'FRENCH' },
    { value: 'FRENLANG', label: 'FRENLANG' },
    { value: 'GENE', label: 'GENE' },
    { value: 'GEOPHYS', label: 'GEOPHYS' },
    { value: 'GEP', label: 'GEP' },
    { value: 'GERLANG', label: 'GERLANG' },
    { value: 'GERMAN', label: 'GERMAN' },
    { value: 'GLOBAL', label: 'GLOBAL' },
    { value: 'GREELANG', label: 'GREELANG' },
    { value: 'GSBGEN', label: 'GSBGEN' },
    { value: 'GSBGID', label: 'GSBGID' },
    { value: 'HAITLANG', label: 'HAITLANG' },
    { value: 'HAWALANG', label: 'HAWALANG' },
    { value: 'HEBRLANG', label: 'HEBRLANG' },
    { value: 'HINDLANG', label: 'HINDLANG' },
    { value: 'HISTORY', label: 'HISTORY' },
    { value: 'HORSE', label: 'HORSE' },
    { value: 'HPS', label: 'HPS' },
    { value: 'HRMGT', label: 'HRMGT' },
    { value: 'HRP', label: 'HRP' },
    { value: 'HUMBIO', label: 'HUMBIO' },
    { value: 'HUMRTS', label: 'HUMRTS' },
    { value: 'HUMSCI', label: 'HUMSCI' },
    { value: 'IGBOLANG', label: 'IGBOLANG' },
    { value: 'IIS', label: 'IIS' },
    { value: 'ILAC', label: 'ILAC' },
    { value: 'IMMUNOL', label: 'IMMUNOL' },
    { value: 'INDE', label: 'INDE' },
    { value: 'INTLPOL', label: 'INTLPOL' },
    { value: 'INTNLREL', label: 'INTNLREL' },
    { value: 'ITALIAN', label: 'ITALIAN' },
    { value: 'ITALIC', label: 'ITALIC' },
    { value: 'ITALLANG', label: 'ITALLANG' },
    { value: 'JAPAN', label: 'JAPAN' },
    { value: 'JAPANLNG', label: 'JAPANLNG' },
    { value: 'JEWISHST', label: 'JEWISHST' },
    { value: 'KORLANG', label: 'KORLANG' },
    { value: 'LAKOTLNG', label: 'LAKOTLNG' },
    { value: 'LATINAM', label: 'LATINAM' },
    { value: 'LAW', label: 'LAW' },
    { value: 'LINGUIST', label: 'LINGUIST' },
    { value: 'MATH', label: 'MATH' },
    { value: 'MATSCI', label: 'MATSCI' },
    { value: 'MCP', label: 'MCP' },
    { value: 'ME', label: 'ME' },
    { value: 'MED', label: 'MED' },
    { value: 'MGTECON', label: 'MGTECON' },
    { value: 'MI', label: 'MI' },
    { value: 'MKTG', label: 'MKTG' },
    { value: 'MLA', label: 'MLA' },
    { value: 'MS&E', label: 'MS&E' },
    { value: 'MTL', label: 'MTL' },
    { value: 'MUSIC', label: 'MUSIC' },
    { value: 'NAHUALNG', label: 'NAHUALNG' },
    { value: 'NATIVEAM', label: 'NATIVEAM' },
    { value: 'NBIO', label: 'NBIO' },
    { value: 'NENS', label: 'NENS' },
    { value: 'NEPR', label: 'NEPR' },
    { value: 'NSUR', label: 'NSUR' },
    { value: 'NVJOLANG', label: 'NVJOLANG' },
    { value: 'OB', label: 'OB' },
    { value: 'OBGYN', label: 'OBGYN' },
    { value: 'OCEANS', label: 'OCEANS' },
    { value: 'OIT', label: 'OIT' },
    { value: 'OPHT', label: 'OPHT' },
    { value: 'ORALCOMM', label: 'ORALCOMM' },
    { value: 'ORTHO', label: 'ORTHO' },
    { value: 'OSPBEIJ', label: 'OSPBEIJ' },
    { value: 'OSPBER', label: 'OSPBER' },
    { value: 'OSPCPTWN', label: 'OSPCPTWN' },
    { value: 'OSPFLOR', label: 'OSPFLOR' },
    { value: 'OSPKYOTO', label: 'OSPKYOTO' },
    { value: 'OSPMADRD', label: 'OSPMADRD' },
    { value: 'OSPOXFRD', label: 'OSPOXFRD' },
    { value: 'OSPPARIS', label: 'OSPPARIS' },
    { value: 'OSPSANTG', label: 'OSPSANTG' },
    { value: 'OTOHNS', label: 'OTOHNS' },
    { value: 'OUTDOOR', label: 'OUTDOOR' },
    { value: 'PAS', label: 'PAS' },
    { value: 'PATH', label: 'PATH' },
    { value: 'PEDS', label: 'PEDS' },
    { value: 'PERSLANG', label: 'PERSLANG' },
    { value: 'PHIL', label: 'PHIL' },
    { value: 'PHYSICS', label: 'PHYSICS' },
    { value: 'PHYSWELL', label: 'PHYSWELL' },
    { value: 'POLECON', label: 'POLECON' },
    { value: 'POLISCI', label: 'POLISCI' },
    { value: 'POLSHLNG', label: 'POLSHLNG' },
    { value: 'PORTLANG', label: 'PORTLANG' },
    { value: 'PSYC', label: 'PSYC' },
    { value: 'PSYCH', label: 'PSYCH' },
    { value: 'PUBLPOL', label: 'PUBLPOL' },
    { value: 'PUNJLANG', label: 'PUNJLANG' },
    { value: 'PWR', label: 'PWR' },
    { value: 'QUECHLNG', label: 'QUECHLNG' },
    { value: 'RAD', label: 'RAD' },
    { value: 'RADO', label: 'RADO' },
    { value: 'REES', label: 'REES' },
    { value: 'RELIGST', label: 'RELIGST' },
    { value: 'RESPROG', label: 'RESPROG' },
    { value: 'ROTCAF', label: 'ROTCAF' },
    { value: 'ROTCARMY', label: 'ROTCARMY' },
    { value: 'ROTCNAVY', label: 'ROTCNAVY' },
    { value: 'RUSSLANG', label: 'RUSSLANG' },
    { value: 'SAMOALNG', label: 'SAMOALNG' },
    { value: 'SBIO', label: 'SBIO' },
    { value: 'SINY', label: 'SINY' },
    { value: 'SIW', label: 'SIW' },
    { value: 'SLAVIC', label: 'SLAVIC' },
    { value: 'SLE', label: 'SLE' },
    { value: 'SNSKTLNG', label: 'SNSKTLNG' },
    { value: 'SOC', label: 'SOC' },
    { value: 'SOMGEN', label: 'SOMGEN' },
    { value: 'SPANLANG', label: 'SPANLANG' },
    { value: 'STATS', label: 'STATS' },
    { value: 'STEMREM', label: 'STEMREM' },
    { value: 'STRAMGT', label: 'STRAMGT' },
    { value: 'STS', label: 'STS' },
    { value: 'SURG', label: 'SURG' },
    { value: 'SUST', label: 'SUST' },
    { value: 'SUSTAIN', label: 'SUSTAIN' },
    { value: 'SWAHLANG', label: 'SWAHLANG' },
    { value: 'SYMSYS', label: 'SYMSYS' },
    { value: 'TAPS', label: 'TAPS' },
    { value: 'TIGRYLNG', label: 'TIGRYLNG' },
    { value: 'TURKLANG', label: 'TURKLANG' },
    { value: 'TWILANG', label: 'TWILANG' },
    { value: 'UAR', label: 'UAR' },
    { value: 'UKRNLANG', label: 'UKRNLANG' },
    { value: 'URBANST', label: 'URBANST' },
    { value: 'URDULANG', label: 'URDULANG' },
    { value: 'UROL', label: 'UROL' },
    { value: 'VIETLANG', label: 'VIETLANG' },
    { value: 'YDDSHLNG', label: 'YDDSHLNG' },
    { value: 'YORULANG', label: 'YORULANG' }
]

export function getAllDepts(user_email: string): { value: string; label: string }[] {
    const schoolId = getSchoolIdFromEmail(user_email)
    switch (schoolId) {
        case 'stanford': return allDepts_Stanford
        case 'ucla': return allDepts_UCLA
        case 'usc': return allDepts_UCB // USC uses UCB depts as default for now
        default: return allDepts_UCB
    }
}

